import { DateOption } from '../../../NearestDatesPicker';
import MonthsWithWidths from '../types/MonthsWithWidths';

type Options = {
    dates: Array<DateOption>;
    widthPerDate: number;
    spacing: number;
};

const determineMonthWidths = ({
    dates,
    widthPerDate,
    spacing,
}: Options): MonthsWithWidths => {
    if (dates.length === 0) {
        return [];
    }

    const calcWidth = (dates: number): number => {
        return (widthPerDate + spacing) * dates - spacing;
    };

    const result: MonthsWithWidths = [];
    let indexOfLastPlacement = 0;
    let lastPlacement = dates[0]!.date;

    dates.forEach(({ date }, index) => {
        if (index === 0) {
            return;
        }

        if (date.day === 1) {
            result.push({
                month: lastPlacement,
                width: calcWidth(index - indexOfLastPlacement),
            });

            lastPlacement = date;
            indexOfLastPlacement = index;
        }
    });

    result.push({
        month: lastPlacement,
        width: calcWidth(dates.length - 1 - indexOfLastPlacement),
    });

    return result;
};

export default determineMonthWidths;
